import { HttpErrorResponse } from '@angular/common/http';
import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { ConfirmarCodigoService } from '../../shared/confirmar-codigo/confirmar-codigo.service';

/**
 * D-144: si el servidor pide el código otra vez antes de mover dinero, se pide en una ventana y
 * la operación se repite sola (misma petición, misma clave de idempotencia). Si la persona
 * cancela, sigue el error original.
 */
export const reconfirmarInterceptor: HttpInterceptorFn = (req, next) => {
  const confirmar = inject(ConfirmarCodigoService);
  return next(req).pipe(
    catchError((error: unknown) => {
      const esReconfirmar = error instanceof HttpErrorResponse && error.status === 403 && error.error?.error?.code === 'REQUIERE_2FA_RECIENTE';
      if (!esReconfirmar) return throwError(() => error);
      return from(confirmar.pedir()).pipe(switchMap((ok) => (ok ? next(req) : throwError(() => error))));
    }),
  );
};
